import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { parse, startOfMonth, endOfMonth, format, Locale } from 'date-fns';
import { fr, enGB, es } from 'date-fns/locale';


@Injectable()
export class CustomDateParserFormatterService extends NgbDateParserFormatter  {
  private locales: Map<string, Locale>;
  constructor(private translateSvc: TranslateService) {
    super();
    this.locales = new Map<string, Locale>([['fr', fr], ['en', enGB], ['es', es]]);

  }
	readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
		if (value) {
			const date =  parse(value, 'P', new Date(), { locale: this.locales.get(this.translateSvc.currentLang) });
			return {
				day: date.getDate(),
				month: date.getMonth() + 1,
				year: date.getFullYear(),
			};
		}
		return null;
	}

	format(date: NgbDateStruct | null): string {
    let dt: Date;
    if (date) {
      dt = new Date(date.year, date.month - 1, date.day);
    } else {
      return '';
    }
    return format(dt, 'P', { locale: this.locales.get(this.translateSvc.currentLang) });
	}
}
